import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import ErrorIcon from '@material-ui/icons/Error'
import { Theme, TableRow, TableCell, Link, Box } from '@material-ui/core'
import messages from '../../../../messages'
import { ConfigContext } from '../../Genomics'
import { useIntl, FormattedMessage } from 'react-intl'
import { useCustomCrisprSaveToSessionMutation } from '@src/mutations/ConfiguratorTubesMutation.generated'
import { useRouter, genomicsRoute } from '@src/routes'
import { ActiveLinkType } from '../../enum'
import DeleteDialog from '../../../../components/DeleteDialog'
import ValidationErrors from '../../../../validations/ValidationErrors'
import ViewCrisprItem from '../../ViewCrisprItem/ViewCrisprItem'
import DataTable from '@src/routes/Configurators/components/DataTable'
import CloseIcon from '@material-ui/icons/Close'
import { ListSubModel } from '@src/types/graphql-types'
import { SequenceListProps } from '@src/routes/Configurators/components/ConfiguratorTypes'
import LinkStyleButton from '@src/components/LinkStyleButton'
const useStyles = makeStyles((theme: Theme) => ({
  errorIcon: {
    color: theme.palette.rich.red,
  },
  sequeceListHeader: {
    margin: theme.spacing(10, 0, 0, 0),
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightBold,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  deleteAllLink: {
    fontSize: theme.typography.pxToRem(14),
    cursor: 'pointer',
  },
  upperCase: {
    textTransform: 'uppercase',
  },
  deleteCloseIcon: {
    fontSize: theme.typography.pxToRem(15),
    cursor: 'pointer',
  },
  tableRowError: {
    borderTop: 'none !important',
    height: 'auto !important',
  },
  tabelCellError: {
    padding: theme.spacing(0, 3, 4, 3),
  },
  errorColumn: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  errorIconNew: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.error.main,
    marginTop: theme.spacing(1 / 2),
  },
  validationRootStyle: {
    paddingTop: theme.spacing(0),
  },
  errorinList: {
    display: 'flex',
    marginTop: theme.spacing(4),
    alignItems: 'center',
    gap: 6,
  },
}))

const SequenceList = ({
  productDetails,
  setDisable,
  setErrorMsg,
}: SequenceListProps) => {
  const classes = useStyles()
  const { state, dispatch } = React.useContext(ConfigContext)
  const intl = useIntl()
  const { sessionListSubModel, sessionData, currentSubModelIndex } = state
  const [delDialogOpen, setDelDialogOpen] = useState(false)
  const [delItem, setDelItem] = useState()
  const [delType, setDelType] = useState('')
  const [isPageError, setIsPageError] = useState(false)
  const [viewItem, setViewItem] = useState<ListSubModel>()
  const [selectedItemIndex, setSelectedItemIndex] = useState<number>(0)
  const [isDelete, setIsDelete] = useState(false)
  const [dialogOpen, setDialogOpen] = useState(false)
  const router = useRouter()
  const sequencePath = `${genomicsRoute.index()}?product=${
    productDetails.productType
  }&activeLink=${ActiveLinkType.SequenceEntry}`

  const handleDelete = (item) => {
    setDelDialogOpen(true)
    setDelType('Selected')
    setDelItem(item)
  }

  const [customCrisprSaveToSession] = useCustomCrisprSaveToSessionMutation()
  const saveToSession = async (data) => {
    await customCrisprSaveToSession({
      variables: { input: data, productInput: productDetails },
    })
  }
  const setInitialState = () => {
    return {
      name: '',
      geneId: '',
      geneSymbol: '',
      sequence: '',
      id: 1,
      isOverridden: false,
      baseCount: 0,
      isCurrentForm: true,
      cartId: '',
      itemId: '',
    }
  }
  const initialSessionData = () => {
    return [
      {
        id: 1,
        isOverridden: false,
        productType: 'customcrispr',
        terms: false,
        listSubModels: [
          {
            name: '',
            geneId: '',
            geneSymbol: '',
            sequence: '',
            id: 1,
            isOverridden: false,
            baseCount: 0,
            isCurrentForm: true,
            cartId: '',
            itemId: '',
          },
        ],
        physicalMaterial: '',
        format: 'DRY',
        pageNo: 0,
        purification: '',
        structure: '',
        modification: '',
        scale: '',
        species: '',
        listVectors: [''],
        listAmount: [''],
        listLentiviralBackbones: [''],
        listViralTiters: [''],
        listVolumes: [''],
        listAliquotings: [''],
        listPurification: [''],
        listSpecies: [''],
        listScale: [''],
        listModification: [''],
        listStructure: [''],
        listPhysicalMaterials: [],
        price: '',
        currencySymbol: '',
        currency: '',
        modifiedSequence: '',
        modifiedTechnicalSequence: '',
      },
    ]
  }

  const deleteCrisprItem = (item, type) => {
    setDisable(false)
    let isDeleteAll = false
    if (type === 'Selected') {
      if (currentSubModelIndex !== 1) {
        const array = [...state.sessionData[0].listSubModels]
        const index = array.indexOf(item)
        if (index !== -1) {
          array.splice(index, 1)
        }
        sessionData[0].listSubModels = array
        dispatch({
          type: 'UPDATE_CURRENT_INDEX',
          data: array.length - 1,
        })
        dispatch({
          type: 'UPDATE_LIST_SUB_MODEL',
          data: array,
        })
        dispatch({
          type: 'UPDATE_INPUT',
          data: [...sessionData],
        })

        setIsDelete(true)
        saveToSession(sessionData)
      } else {
        //only one item left
        isDeleteAll = true
      }
    } else if (type === 'All') {
      isDeleteAll = true
    }
    if (isDeleteAll) {
      router.push(sequencePath)
      dispatch({
        type: 'CRISPR_SEQUENCE_LIST',
        data: false,
      })
      dispatch({
        type: 'UPDATE_CURRENT_INDEX',
        data: 0,
      })
      dispatch({
        type: 'UPDATE_LIST_SUB_MODEL',
        data: [setInitialState()],
      })
      dispatch({
        type: 'UPDATE_INPUT',
        data: initialSessionData(),
      })
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
      dispatch({ type: 'IS_DISPLAY_ERROR', data: false })
      setErrorMsg('')
      dispatch({
        type: 'UPDATE_ERRORS',
        data: [],
      })
      saveToSession([])
    }
    if (state.stepNo !== 0) {
      dispatch({ type: 'SET_STEP_NO', data: 0 })
    }
  }

  React.useEffect(() => {
    if (isDelete) {
      let isListErrorRemaning = false
      sessionData[0].listSubModels.forEach((listModel) => {
        if (
          listModel.listSubModelErrors?.length !== 0 &&
          !isListErrorRemaning
        ) {
          setIsPageError(true)
          isListErrorRemaning = true
        } else {
          setIsPageError(false)
          dispatch({
            type: 'SET_PAGE_ERROR',
            data: '',
          })
          dispatch({ type: 'IS_DISPLAY_ERROR', data: false })
          setErrorMsg('')
        }
      })
      setIsDelete(false)
    }
    setDisable(false)
  }, [sessionData])

  const displaySessionData = (item, index) => {
    setDialogOpen(true)
    setViewItem(item)
    setSelectedItemIndex(index)
  }

  const getErrorMessages = (row) => {
    const errorMessage: string[] = []
    if (row?.listSubModelErrors?.length && !row?.isCurrentForm) {
      setDisable(true)
      row.listSubModelErrors.forEach((error) => {
        const { key, value } = error
        if (
          key &&
          value &&
          key === messages.CONF_REVIEW_ERROR_MSG.defaultMessage
        ) {
          errorMessage.push(value)
        }
      })
      if (!isPageError) {
        setIsPageError(true)
      }
    }
    return errorMessage
  }

  const hasErrorInList = () => {
    const errors = sessionListSubModel
      ?.map((item) => getErrorMessages(item))
      ?.filter((item) => item?.length)
    return !!errors?.length
  }

  React.useEffect(() => {
    if (isPageError) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
      })
      window.scrollTo(0, 0)
      setIsPageError(false)
    }
  }, [])

  const tableColumns = [
    {
      headElement: <FormattedMessage {...messages.NAME} />,
      bodyElement: (row, index) => (
        <div className={classes.errorColumn}>
          {row?.listSubModelErrors?.length ? (
            <ErrorIcon className={classes.errorIconNew} />
          ) : null}
          <LinkStyleButton
            id="customCrispr-table-name-link"
            onClick={() => displaySessionData(row, index)}
          >
            {row.name}
          </LinkStyleButton>
        </div>
      ),
      errorMessages: (row) => getErrorMessages(row),
    },
    {
      headElement: <FormattedMessage {...messages.CONF_BASES} />,
      bodyElement: (row) =>
        row?.listSubModelErrors?.length ? '--' : row.baseCount,
      errorMessages: (row) => getErrorMessages(row),
    },
    {
      headElement: <FormattedMessage {...messages.CONF_SEQUENCE_LABEL} />,
      bodyElement: (row) => row.sequence || '--',

      errorMessages: (row) => getErrorMessages(row),
      width: '35%',
    },
    {
      headElement: <FormattedMessage {...messages.GENE_ID} />,
      bodyElement: (row) => row.geneId || '--',

      errorMessages: (row) => getErrorMessages(row),
    },
    {
      headElement: <FormattedMessage {...messages.GENE_SYMBOL} />,
      bodyElement: (row) => row.geneSymbol || '--',

      errorMessages: (row) => getErrorMessages(row),
    },
    {
      headElement: <FormattedMessage {...messages.DELETE} />,
      bodyElement: (row) => (
        <CloseIcon
          id="customCrispr-delete-close-icon"
          className={classes.deleteCloseIcon}
          onClick={() => {
            handleDelete(row)
          }}
        />
      ),
      textAlign: 'center' as const,
    },
  ]

  return (
    <>
      <>
        <div className={classes.sequeceListHeader}>
          <span className={classes.upperCase}>
            <FormattedMessage {...messages.CONF_CRISPR_SEQUENCE_LIST} />
          </span>
          <Link
            id="customCrispr-deleteAll-link"
            onClick={() => {
              setDelDialogOpen(true)
              setDelType('All')
              setDelItem(delItem)
            }}
            className={classes.deleteAllLink}
          >
            <FormattedMessage {...messages.CONF_DELETE_ALL_BUTTON} />
          </Link>
        </div>
        {hasErrorInList() ? (
          <div className={classes.errorinList}>
            <ErrorIcon className={classes.errorIconNew} />
            <FormattedMessage {...messages.CONFIG_PLEASE_CORRECT_ERRORS} />
          </div>
        ) : null}
        <Box mt={6}>
          <DataTable
            data={sessionListSubModel}
            columns={tableColumns}
            afterRow={(data) => {
              const errorMessages = getErrorMessages(data)
              return errorMessages.length ? (
                <TableRow className={classes.tableRowError}>
                  <TableCell colSpan={6} className={classes.tabelCellError}>
                    <div>
                      <ValidationErrors
                        errors={errorMessages}
                        configuratorsRedesign
                        showIcon={false}
                        rootClass={classes.validationRootStyle}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              ) : (
                <></>
              )
            }}
          />
        </Box>
      </>

      <DeleteDialog
        dialogOpen={delDialogOpen}
        setDialogOpen={setDelDialogOpen}
        selectedItem={delItem}
        type={delType}
        onDelete={deleteCrisprItem}
      />
      {dialogOpen && (
        <ViewCrisprItem
          dialogOpen={dialogOpen}
          setDialogOpen={setDialogOpen}
          selectedItem={viewItem}
          selectedItemIndex={selectedItemIndex}
          productDetails={productDetails}
          isSequenceEntryPage
        ></ViewCrisprItem>
      )}
    </>
  )
}

export default SequenceList
